var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.root},[_c('div',{staticClass:"bottom"},[_vm._v("Copyright © 2018南京超然科技有限公司 苏ICP备05079548号-1")])])}
var staticRenderFns = []

export { render, staticRenderFns }